import { Supplier } from '..';

export const emptySupplier: Supplier = {
  // @ts-expect-error
  uuid: null,
  // @ts-expect-error
  name: null,
  // @ts-expect-error
  language: null,
  // @ts-expect-error
  category: { name: null, uuid: null },
  // @ts-expect-error
  status: null,
  // @ts-expect-error
  timezone: null,
  // @ts-expect-error
  country: null,
  // @ts-expect-error
  city: null,
  invoices: [],
  estimates: [],
  // @ts-expect-error
  createdAt: null,
  // @ts-expect-error
  updatedAt: null,
  emails: [],
  phones: [],
  // @ts-expect-error
  address: null,
  // @ts-expect-error
  address2: null,
  // @ts-expect-error
  logo: null,
  contactSupplierRoles: [],
  // @ts-expect-error
  btwVat: null,
  // @ts-expect-error
  currency: null,
  // @ts-expect-error
  bankAccount: null,
  // @ts-expect-error
  bic: null,
  // @ts-expect-error
  zip: null,
};
